import {Dropdown, Form, FormCheck} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {deleteStatics,setStatics} from "../../../actions/DataActions";
import {FormGroup, Input, Label} from "reactstrap";
// UNUSED COMPONENT
const StaticticsPicker = ({PlotData: {stats, hide_data, loading},setStatics,deleteStatics}) => {

    const setStats =(stat)=>{
        let newStats = stats;
        switch (stat) {
            case "AVG":
            {
                newStats.avg=!newStats.avg;
                break;
            }
            case "UPPER":
            {
                newStats.upperQuarter=!newStats.upperQuarter;
                break;
            }
            case "LOWER":
            {
                newStats.lowerQuarter=!newStats.lowerQuarter;
                break;
            }
            default:
                console.error("NO stats")
        }
        setStatics(newStats)

    };

    return (
        <Dropdown style={{"opacity": "1"}} className={"ml-auto justify-content-end"} autoclose={"false"}>
            {loading
                ?
                <Dropdown.Toggle variant="info" id="dropdown-autoclose-false" disabled={true}>
                    Ładowanie Danych
                </Dropdown.Toggle>
                :
                <Dropdown.Toggle variant="info" id="dropdown-autoclose-false" disabled={false}>
                    Wybierz:
                </Dropdown.Toggle>

            }

            <Dropdown.Menu className={"p-1"}>
                   <FormGroup style={{"backgroundColor":stats.avg ?"#f5f5f5":"white"}} check className='wskaznikiCheckBox'>
                    <Label for={"AVG"} check>
                        <Input type="checkbox" name="dataPoint" id={"AVG"} onClick={()=>setStats("AVG") }
                             checked={stats.avg}   />
                        <span className="form-check-sign"/>
                        Średnia</Label>
                </FormGroup>
                <FormGroup style={{"backgroundColor":stats.upperQuarter ? "#f5f5f5":"white"}} check className='wskaznikiCheckBox'>
                    <Label for={"UPPER"} check>
                        <Input type="checkbox" name="dataPoint" id={"UPPER"} onClick={()=>setStats("UPPER")}
                              checked={stats.upperQuarter}  />
                        <span className="form-check-sign"/>
                        Górny kwartyl</Label>
                </FormGroup>
                <FormGroup style={{"backgroundColor":stats.lowerQuarter ? "#f5f5f5":"white"}} check className='wskaznikiCheckBox'>
                    <Label for={"LOWER"} check>
                        <Input type="checkbox" name="dataPoint" id={"LOWER"} onClick={()=>setStats("LOWER")}
                             checked={stats.lowerQuarter}   />
                        <span className="form-check-sign"/>
                        Dolny kwartyl</Label>
                </FormGroup>
            </Dropdown.Menu>
        </Dropdown>
    );
};


const mapStateToProps = state => ({
    PlotData: state.PlotData

});
export default connect(mapStateToProps, {setStatics,deleteStatics})(StaticticsPicker)